import * as React from 'react';
import { useState } from 'react';
import {
    BodyMediumEmphasized,
    ChevronRightIcon,
    Icon,
    LabelRegular,
    TargetIcon,
    View,
    XStack,
    YStack,
} from 'smoothie';

import CreateGoalAccountLinkSheet from './CreateGoalAccountLinkSheet';

interface LinkAccountButtonProps {
    goalId: string;
}

const LinkAccountButton = ({ goalId }: LinkAccountButtonProps) => {
    const [isSheetOpen, setIsSheetOpen] = useState(false);

    return (
        <>
            <XStack
                gap={10}
                width="100%"
                padding={12}
                borderWidth={1}
                borderColor="$gray200"
                borderRadius={12}
                onPress={() => {
                    setIsSheetOpen(true);
                }}
                animation="button"
                pressStyle={{
                    scale: 0.95,
                }}
            >
                <Icon icon={TargetIcon} size={20} />
                <YStack maxWidth={200}>
                    <BodyMediumEmphasized>
                        Track your progress
                    </BodyMediumEmphasized>
                    <LabelRegular color="$gray1000">
                        Link the account where you’re working towards this goal
                    </LabelRegular>
                </YStack>
                <View marginLeft="auto" alignSelf="center">
                    <Icon icon={ChevronRightIcon} size={18} color="$gray900" />
                </View>
            </XStack>
            {isSheetOpen && (
                <CreateGoalAccountLinkSheet
                    goalId={goalId}
                    onDismiss={() => {
                        setIsSheetOpen(false);
                    }}
                />
            )}
        </>
    );
};

export default LinkAccountButton;
